import { Box, Loader, ModBox, Text, useWindowDimensions } from '@jfs/ui-new'
import { useFocusEffect, useNavigation } from '@react-navigation/native'
import React, { useEffect, useState } from 'react'
import ActionsMenu from '../../../components/ActionMenu/ActionsMenu'
import { Filters } from '../../../components/FiltersWeb'
import { filterTypes } from '../../../components/FiltersWeb/types'
import { NewTable } from '../../../components/NewTable'
import { useLazyApiData, useStores } from '../../../data/store'
import { filtersAuditData, filtersData } from '../../../utils'
import { fiuCheckerHeaderTitles, getCustomColumnWidth } from '../../../utils/constants'
import { styles } from '../FiuQueue'

const Header = ({ fetchDataOnChange, filterVisible, setFilterVisible, filterApplied }: any) => {
  return (
    <Box {...styles.header}>
      <ModBox w={'100%'}>
        <Text title={'Fiu Maker Queue'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
        <ActionsMenu
          fetchDataOnChange={fetchDataOnChange}
          filterVisible={filterVisible}
          setFilterVisible={setFilterVisible}
          showSearch={true}
          enableFilter
          showCalendar
          defaultPage={1}
          type="fiuMaker"
          filterApplied={filterApplied}
        />
      </ModBox>
    </Box>
  )
}
const FiuMakerQueue = () => {
  const {
    fetchMakerList,
    getMakerList,
    selectedFilteredData,
    updateFilters,
    makerListlength,
    setSideMenuRefresh,
    saveState,
    resetState,
    restoreFiltersToDefaults,
    setSearchFilterBy,
    resetFeePkgId,
    resetCheckerApplicationStatus,
    checkSelected,
  } = useStores((store) => ({
    fetchMakerList: store.fetchFiuMakerList,
    getMakerList: store.getFiuMakerList,
    selectedFilteredData: store.filter.getFilterData,
    updateFilters: store.filter.updateFilters,
    makerListlength: store.makerList.length,
    setSideMenuRefresh: store.setSideMenuRefresh,
    saveState: store.filter.saveState,
    resetState: store.filter.resetState,
    restoreFiltersToDefaults: store.filter.restoreFiltersToDefaults,
    applicationStatusLength: store.filter.applicationStatus.length,
    setSearchFilterBy: store.onboarding.setSearchFilterBy,
    resetFeePkgId: store.onboarding.resetFeePkgId,
    resetCheckerApplicationStatus: store.resetCheckerApplicationStatus,
    checkSelected: store.filter.checkSelected,
    fiuMakerListLength: store.fiuMakerList.length,
  }))
  const navigation = useNavigation()
  const [listData, setListData] = useState<any>([])
  const [isLoading, setLoading] = useState(false)
  const [filterVisible, setFilterVisible] = useState(false)

  const [lazyFetchMakerListList, { state }] = useLazyApiData(fetchMakerList)

  useEffect(() => {
    if (state === 'fulfilled' || state === 'rejected') {
      const list = getMakerList()
      setListData(list)
      setLoading(false)
    }
  }, [getMakerList, state, makerListlength])

  useFocusEffect(
    React.useCallback(() => {
      setLoading(true)
      lazyFetchMakerListList()
      setSideMenuRefresh(true)
      setSearchFilterBy('Entity ID')
      updateFilters('applicationStatus', 'ALL')
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []),
  )

  const onPress = (item: any) => {
    setSearchFilterBy('Entity ID')
    resetFeePkgId()
    resetCheckerApplicationStatus()

    if (item?.applicationStatus === 'Error') {
      navigation.reset({
        index: 0,
        routes: [
          {
            name: 'fiuDetails',
            params: {
              itemData: item,
              from: 'FIU_MAKER',
              isApprovedByChecker: true,
              showApproveReject: false,
              type: item?.auditType,
            },
          },
        ],
      })
    } else {
      navigation.reset({
        index: 0,
        routes: [
          {
            name: 'fiuDetails',
            params: {
              itemData: item,
              from: 'FIU_MAKER',
              isApprovedByChecker: false,
              showApproveReject: false,
              type: item?.auditType,
            },
          },
        ],
      })
    }
    setSideMenuRefresh(true)
  }

  const { width } = useWindowDimensions()

  const fetchDataOnChange = () => {
    console.count('===> fetchDataOnChange')
    setLoading(true)
    lazyFetchMakerListList()
  }

  const onFilterPress = () => {
    setFilterVisible(false)
    resetState()
  }

  const applyFilter = () => {
    fetchDataOnChange()
    setFilterVisible(false)
  }

  const handleFilterVisibility = (visible: boolean) => {
    setFilterVisible(visible)
    if (visible) {
      saveState()
    }
  }

  const restoreFilterDefaults = () => {
    restoreFiltersToDefaults()
  }

  if (isLoading) {
    return <Loader />
  }
  return (
    <Box {...styles.container}>
      <Header
        fetchDataOnChange={fetchDataOnChange}
        filterVisible={filterVisible}
        setFilterVisible={handleFilterVisibility}
        filterApplied={
          (selectedFilteredData?.applicationStatus?.length > 0 &&
            (selectedFilteredData?.applicationStatus?.includes('Completed') ||
              selectedFilteredData?.applicationStatus?.includes('Rejected') ||
              selectedFilteredData?.applicationStatus?.includes('Error') ||
              selectedFilteredData?.applicationStatus?.includes('Pending For Approval'))) ||
          !selectedFilteredData?.auditType?.includes('ALL')
        }
      />
      <ModBox padding={16} show={!filterVisible}>
        <NewTable
          data={listData}
          rowHeight={48}
          headerHeight={64}
          height={544}
          customWidthFunc={getCustomColumnWidth}
          tableWidth={width > 1200 ? width - 290 : width}
          headerRowKeys={fiuCheckerHeaderTitles}
          onRowClick={onPress}
          freezeColumn={'check'}
          freezeColumnWidth={50}
        />
      </ModBox>
      <ModBox show={filterVisible}>
        <Filters
          onPress={onFilterPress}
          selectedFilteredData={selectedFilteredData}
          updateFilters={updateFilters}
          filterData={[filtersData, filtersAuditData]}
          checkSelected={checkSelected}
          apply={applyFilter}
          selectedValue={selectedFilteredData?.applicationStatus}
          mode={filterTypes.applicationStatus}
          restoreDefaults={restoreFilterDefaults}
        />
      </ModBox>
    </Box>
  )
}

export default FiuMakerQueue
